package com.essntl.uikit.key

import androidx.compose.runtime.staticCompositionLocalOf

val LocalKeyboardState = staticCompositionLocalOf { KeyboardState() }